<section>
    <div class="container h-100">
        <div class="row align-item-center h-100 flex-row-reverse">
            <!-- MultiStep Form -->

            <div class="col-lg-7 h-100 offset-lg-1">
                <div class="h-100 py-5">
                    <div class="logo text-center mb-5">
                        <img src="assets/images/logo-color.png" class="img-fluid" alt="Brand Tracker Study" width=""
                            height="" />
                    </div>
                    <form id="msform" #form="ngForm" (ngSubmit)="onSubmit(form)">
                        <fieldset>
                            <div class="fields mb-3">
                                <div class="row single-select-question h-100">
                                    <div class="">
                                        <p class=" mb-5">
                                            <b [innerHTML]="questionData?.question"></b>
                                        </p>
                                    </div>

                                    <!-- Single Select (Radio buttons) -->
                                    <div class="row" *ngIf="type === 'Single Select'">
                                        <div class="col-md-6 mb-3"
                                            *ngFor="let option of questionData.options; let i = index">
                                            <label [for]="'exampleRadios' + i">
                                                <input type="radio" name="Customer-Type" [(ngModel)]="selectedOption"
                                                    [id]="'exampleRadios' + i" [value]="option.options"
                                                    class="form-radio text-info" required />
                                                <span class="flex text-md text-black">{{ option.options }}</span>
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Multi Select (Checkboxes) -->
                                    <div class="row Multi-select-question" *ngIf="type==='Multi Select'">
                                        <div class="col-md-6 mb-3"
                                            *ngFor="let option of questionData.options; let i = index">
                                            <label [for]="'examplecheckboxes' + i"><input type="checkbox"
                                                    name="Customer-Type" [checked]="isChecked(option.options)"
                                                    [id]="'examplecheckboxes' + i" [value]="option.options"
                                                    (change)="onOptionChange(option.options, $event)"
                                                    class="form-checkbox"><span class="flex text-md text-black">{{
                                                    option.options }}</span></label>
                                        </div>
                                    </div>

                                    <!-- Multi Select Dropdown -->
                                    <div class="row Multi-select-dropdown" *ngIf="type === 'DropDown Multi Select'">
                                        <div class="col-md-12 mb-3 ">
                                            <mat-form-field appearance="fill" style="width: 100%;">
                                                <mat-label>Select here</mat-label>
                                                <mat-select [(ngModel)]="selectedOptions" name="selectedOptions"
                                                    multiple>
                                                    <mat-select-trigger>
                                                        <span aria-placeholder="Empty Placeholder"></span>
                                                        <mat-chip-list *ngIf="selectedOptions?.length > 0"
                                                            style="max-height: 50px; overflow-y: auto;">
                                                            <mat-chip *ngFor="let option of selectedOptions"
                                                                style="background-color: #005f75;" selected>
                                                                {{ option }}
                                                                <i class="fa fa-times"
                                                                    (click)="removeChip(option); $event.stopPropagation()"
                                                                    style="margin-left: 10px; color: darkgrey; font-size: 12px; cursor: pointer;">
                                                                </i>
                                                            </mat-chip>
                                                        </mat-chip-list>
                                                        <span *ngIf="selectedOptions?.length === 0">Select here</span>
                                                    </mat-select-trigger>

                                                    <!-- Options from questionData -->
                                                    <mat-option *ngFor="let option of questionData?.options"
                                                        [value]="option.options">
                                                        {{ option.options }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Open-ended Text Input -->
                                    <div class="row Open-Ended-Question" *ngIf="type==='Open End'">
                                        <div class="col-md-12 mb-3">
                                            <input style="color: black !important;" type="text" name="Customer-Type"
                                                class="form-checkbox text-info" [(ngModel)]="selectedOption">
                                        </div>
                                    </div>

                                    <!-- Dropdown Select -->
                                    <div class="row Single-select-dropdown" *ngIf="type === 'Dropdown single select'">
                                        <div class="col-md-12 mb-3">
                                            <mat-form-field appearance="fill" style="width: 100%;">
                                                <mat-label>Select here</mat-label>
                                                <mat-select [(ngModel)]="selectedOption" name="selectedOption"
                                                    [id]="questionData.id">
                                                    <mat-option *ngFor="let option of questionData.options"
                                                        [value]="option.options">
                                                        {{option.options}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <!-- <div class="custom-select">
                                                <select >
                                                    <option *ngFor="let option of questionData.options"
                                                        [value]="option.options">
                                                        {{ option.options }}
                                                    </option>
                                                </select>
                                            </div> -->
                                        </div>
                                    </div>

                                    <!-- Date Range -->
                                    <div class="row" *ngIf="type==='Range'">
                                        <mat-form-field appearance="fill" class="custom-date-input"
                                            (click)="picker.open()">
                                            <mat-label>Choose a date</mat-label>
                                            <input style="width: 100%; border: none; color: black;" matInput
                                                [matDatepicker]="picker" [(ngModel)]="selectedDate"
                                                [ngModelOptions]="{standalone: true}" readonly>
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <!-- Common Error Message -->
                                    <div *ngIf="isFormSubmitted  && !isValidSelection() && type!='DropDown Multi Select' &&  type!='Dropdown single select'"
                                        class="text-danger"><small style="position: relative; bottom: 0.8rem;
                                        margin-left: 0.2rem;">
                                            Please provide a response before proceeding.</small>
                                    </div>
                                    <div *ngIf="isFormSubmitted  && !isValidSelection() && (type ==='DropDown Multi Select')"
                                        class="text-danger"><small style="position: relative; bottom: 3rem;">
                                            Please provide a response before proceeding.</small>
                                    </div>
                                    <div *ngIf="isFormSubmitted  && !isValidSelection() && (type ==='Dropdown single select')"
                                        class="text-danger"><small style="position: relative; bottom: 2rem;">
                                            Please provide a response before proceeding.</small>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="next action-button" (click)="onSubmit(form)"
                                [disabled]="loading">
                                Next
                                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                            </button>
                            <!-- <input type="button" name="next"  class="next action-button" (click)="onSubmit(form)"
                                value="Next"/> -->
                        </fieldset>
                    </form>
                </div>
            </div>
            <div class="col-lg-4 mb-5 h-100">
                <div class="form-left-side h-100">
                    <h1>Feel free to drop us your feedback.</h1>
                    <div class="left-image">
                        <img src="assets/images/home-banner.png" class="img-fluid" alt="" width="594" height="457" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>